import type { ContractLifecycle, OperatingSowTestFixture } from '../types'

export function formatCurrency(value?: number | string | null, currency = 'USD') {
  if (value === null || value === undefined || value === '') return '-'
  const numeric = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(numeric)) return '-'
  return `${new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(numeric)} ${currency}`
}

export function formatDate(value?: string | null) {
  if (!value) return '-'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value.slice(0, 10)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(parsed)
}

export function getErrorMessage(error: unknown) {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (error instanceof Error) return error.message
  return 'Request failed'
}

export function getGmailScanErrorMessage() {
  return 'Could not scan Gmail. Confirm Gmail is connected in Admin Settings, then try again. Google Drive and Google Sheets must also be connected to complete the SOW workflow.'
}

export function toInputDate(dateValue: Date) {
  return dateValue.toISOString().slice(0, 10)
}

export function defaultOperatingFixture(): OperatingSowTestFixture {
  const start = new Date()
  start.setUTCDate(start.getUTCDate() + 7)
  const end = new Date(start)
  end.setUTCDate(end.getUTCDate() + 28)
  return {
    client: 'ZZZ-TEST Contract Automation',
    start_date: toInputDate(start),
    end_date: toInputDate(end),
    num_lead_fde: 1,
    num_fde: 1,
    num_pm: 1,
  }
}

export function lifecycleValue(lifecycle: ContractLifecycle, key: keyof ContractLifecycle) {
  return lifecycle[key] || 'unknown'
}
